// extracted by mini-css-extract-plugin
export default {"userInfo":"userInfo_GyCIG","avtar":"avtar_i9bJw","avatarImg":"avatarImg_BhlM_","userName":"userName_ksCEw"};